// COMMON: Komponenta pro osetreni informacnich boxu (odeberte, pokud nepouzivate funkcionalitu/extenzi AlertBox)
import AlertBox from 'fg-frontend/src/components/AlertBox';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'WebLayout':
      return import('./components/WebLayout');
    case 'AlertBox':
      return AlertBox;
    case 'GoogleRecaptcha':
      return import('fg-frontend/src/components/GoogleRecaptcha');
    case 'Hamburger':
      return import('./components/Hamburger');
    case 'Search':
      return import('./components/Search');
    case 'ShowMorePhotos':
      return import('./components/ShowMorePhotos');
    case 'Collapse':
      return import('./components/Collapse');
    case 'Modal':
      return import('./components/Modal');
    case 'Map':
      return import('./components/Map');
    default:
      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js